import React from "react";

/** ? button with hover-over tooltip text. */
export const TooltipButton = (props) => {
  return (
    <div className="tooltip tooltip-button">
      ?
      <span className="tooltip-text">{props.text}</span>
    </div>
  )
}

/** Hoverable ! button. The position and color of the button can be set
 * with `props.color` and `props.pos`. On hover, a tooltip is shown -
 * the contents of the tooltip should be set with `props.children`.
 */
const Hotspot = (props) => {
  return (
    <div className={`tooltip hotspot-button ${props.color}`} style={{
      top: props.pos.top, left: props.pos.left
    }}>
      !
      {props.children}
    </div>
  )
}

/** ! button with tooltip text shown on hover (`props.text`). */
export const HotspotButton = (props) => {
  return (
    <Hotspot pos={props.pos} color={props.color}>
      <div className="tooltip-text">
        <span><b>{props.title}</b></span>
        <br/>
        <div>{props.text}</div>
      </div>
    </Hotspot>
  )
}

/** ! button with a carousel of tooltip text shown on hover. */
export const HotspotCarousel = (props) => {
  const [activeSlide, setActiveSlide] = React.useState(0);

  const incrementSlide = () => {
    setActiveSlide((activeSlide + 1) % props.children.length);
  }

  const decrementSlide = () => {
    const len = props.children.length;
    setActiveSlide((((activeSlide - 1) % len) + len) % len);
  }

  if (props.children.length) {
    // only show if any of the children items are active/being shown
    return (
      <div className="hotspot-carousel tooltip" style={{
        top: props.pos.top, left: props.pos.left
      }}>
        {props.children[activeSlide]}
        <div className="carousel-nav">

          {/* only show these if there is more than 2 child elements */}
          {props.children.length >= 2 && 
            <>
              <button className="game-input-btn game-input-btn-dark" onClick={decrementSlide}>{"<"}</button>
              <button className="game-input-btn game-input-btn-dark" onClick={incrementSlide}>{">"}</button>
            </>
          }
        </div>
      </div>
    );
  }

  return <></>;
}